/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import { upsertFooterCms } from 'api/services/cmsServices';
import { getFooterCmsService } from 'api/services/cmsServices';
import Card from 'components/card'
import InputField from 'components/fields/InputField';
import TextField from 'components/fields/TextField';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';

const FooterCMS = () => {
    const [formData, setformData] = useState({
        description: "",
        linkedin: "",
        linkedinLogo: "",
        x: "",
        xLogo: "",
    });
    const [error, setError] = useState({
        description: "",
        linkedin: "",
        linkedinLogo: "",
        x: "",
        xLogo: "",
    });

    useEffect(() => {
        getFooterCms();
    }, []);

    const getFooterCms = async () => {
        try {
            let response = await getFooterCmsService();

            if (response.status == 200) {
                let obj = {}
                response?.data?.data?.map(a => {
                    if (a?.type == "footer_description") {
                        obj.description = a?.description
                    } else if (a?.type == "linkedin") {
                        obj.linkedin = a?.title;
                        obj.linkedinLogo = a?.image
                    } else if (a?.type == "x") {
                        obj.x = a?.title
                        obj.xLogo = a?.image
                    }
                })

                setformData(obj)
            }

        } catch (error) {
            console.log(error)
        }
    }


    const handleSave = async (e) => {
        e.preventDefault();
        try {
            let response = await upsertFooterCms(formData)
            if(response?.status == 200) {
                toast.success("Footer updated successfully")
                getFooterCms()
            } else {
                toast.error("Something went wrong")
            }

        } catch (error) {
            toast.error(error.response?.data?.error || "Something went wrong");
        }
    }

    return (
        <Card extra="w-full h-full sm:overflow-auto px-6 pb-5 mt-5">
            <header className="relative flex flex-col gap-4 pt-4">
                <div className="flex items-center justify-between">
                    <form className='w-full'>
                        <TextField
                            label="Footer Description*"
                            placeholder="Enter Description"
                            id="description"
                            type="text"
                            value={formData?.description}
                            onChangeFun={(e) => {
                                setformData({ ...formData, description: e.target.value });
                                setError({ ...error, description: "" });
                            }}
                            rows={3}
                        />
                        {error.description && (
                            <p className="mb-2 ml-2 text-sm text-red-500">{error.description}</p>
                        )}

                        <div className='mt-4'>
                            <InputField
                                label="LinkedIn link*"
                                placeholder="Enter link"
                                id="linkedin"
                                type="text"
                                value={formData?.linkedin}
                                onChangeFun={(e) => {
                                    setformData({ ...formData, linkedin: e.target.value });
                                    setError({ ...error, linkedin: "" });
                                }} />

                            {error.linkedin && (
                                <p className="mb-2 ml-2 text-sm text-red-500">{error.linkedin}</p>
                            )}
                        </div>

                        <div className='mt-4'>
                            <label className="mb-2 mr-4 text-sm font-bold text-navy-700 dark:text-white">
                                LinkedIn Logo*
                            </label>
                            {formData.linkedinLogo && (
                                <div className="mb-2">
                                    <img
                                        src={
                                            typeof formData.linkedinLogo === 'string'
                                                ? formData.linkedinLogo
                                                : URL.createObjectURL(formData.linkedinLogo)
                                        }
                                        alt="LinkedIn Logo"
                                        className="h-16 w-16 object-contain border rounded"
                                    />
                                </div>
                            )}
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setformData({ ...formData, linkedinLogo: file });
                                    setError({ ...error, linkedinLogo: "" });
                                }}
                            />
                            {error.linkedinLogo && (
                                <p className="mb-2 ml-2 text-sm text-red-500">{error.linkedinLogo}</p>
                            )}
                        </div>


                        <div className='mt-4'>
                            <InputField
                                label="Twitter link*"
                                placeholder="Enter link"
                                id="x"
                                type="text"
                                value={formData?.x}
                                onChangeFun={(e) => {
                                    setformData({ ...formData, x: e.target.value });
                                    setError({ ...error, x: "" });
                                }} />

                            {error.x && (
                                <p className="mb-2 ml-2 text-sm text-red-500">{error.x}</p>
                            )}
                        </div>

                        <div className='mt-4'>
                            <label className="mb-2 mr-4 text-sm font-bold text-navy-700 dark:text-white">
                                Twitter Logo*
                            </label>
                            {formData.xLogo && (
                                <div className="mb-2">
                                    <img
                                        src={
                                            typeof formData.xLogo === 'string'
                                                ? formData.xLogo
                                                : URL.createObjectURL(formData.xLogo)
                                        }
                                        alt="Twitter Logo"
                                        className="h-16 w-16 object-contain border rounded"
                                    />
                                </div>
                            )}
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setformData({ ...formData, xLogo: file });
                                    setError({ ...error, xLogo: "" });
                                }}
                            />
                            {error.xLogo && (
                                <p className="mb-2 ml-2 text-sm text-red-500">{error.xLogo}</p>
                            )}
                        </div>


                        <div className="flex justify-end mt-6">
                            <button
                                onClick={(e) => handleSave(e)}
                                className="text-md rounded-md bg-brand-500 px-4 py-1.5 font-semibold text-white shadow transition hover:bg-brand-600"
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </header>
        </Card>
    )
}

export default FooterCMS